import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";

export default function DonationSettings() {
	const [check, setCheck] = useState(null);

	const history = useHistory();

	const location = useLocation();
	const pathName = location.pathname;

	useEffect(() => {
		const checkLink = pathName === "/donate-monthly" ? true : false;
		setCheck(checkLink);
	}, [pathName]);

	const toggleSwitch = () => {
		if (pathName.includes("donate") && pathName !== "/donate-monthly") {
			history.push(`/donate-monthly`);
		} else {
			history.push(`/donate-once`);
		}
	};

	return (
		<div className="donation-settings">
			<span>Donate once</span>
			<Form>
				<Form.Check
					type="switch"
					id="custom-switch"
					onChange={toggleSwitch}
					checked={check}
				/>
			</Form>
			<span>Donate monthly</span>
		</div>
	);
}
